import log from 'salvo-lite/log'

class LoginRegister {
    constructor (theme, elem) {
        this.theme = theme
        this.elem = elem
        this.loginform = null
        this.loginbtn = null
        this.newcust = null
        this.newcustbtn = null
        this.forgotpword = null
        this.forgotbtn = null
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this.loginform = this.elem.querySelector('#customer_login')
        if (this.loginform) {
            this.loginbtn = this.loginform.querySelector('.btn')
            this.forgotpword = this.elem.querySelector('[data-forgot-password]')
            if (this.forgotpword) {
                this.forgotbtn = this.forgotpword.querySelector('.btn')
                this.loginPage()
            }
        }
        this.newcust = this.elem.querySelector('#create_customer')
        if (this.newcust) {
            this.newcustbtn = this.newcust.querySelector('.btn')
        }
    }
    loginPage () {
        this.loginbtn.addEventListener('click', e => {
            localStorage.setItem('form', 'login')
        })
        this.forgotbtn.addEventListener('click', e => {
            localStorage.setItem('form', 'forgot')
        })
        let form = localStorage.getItem('form')
        if (form != null) {
            if (form === 'login') {
                let error = this.loginform.querySelector('.errors')
                if (error) {
                    error.classList.add('error')
                }
                let inputs = this.loginform.querySelectorAll('.text-box')
                if (inputs.length > 0) {
                    for (var l = 0; l < inputs.length; l++) {
                        inputs[l].classList.add('errorbox')
                    }
                }
                localStorage.removeItem('form')
            }
            if (form === 'forgot') {
                let error = this.forgotpword.querySelector('.errors')
                if (error) {
                    error.classList.add('error')
                }
                let inputs = this.forgotpword.querySelectorAll('.text-box')
                if (inputs.length > 0) {
                    for (var p = 0; p < inputs.length; p++) {
                        inputs[p].classList.add('errorbox')
                    }
                }
                localStorage.removeItem('form')
            }
        }
    }
    registerPage () {
        this.newcustbtn.addEventListener('click', e => {
            localStorage.setItem('form', 'cust')
        })
        let form = localStorage.getItem('form')
        if (form != null) {
            if (form === 'cust') {
                let error = this.newcust.querySelector('.errors')
                if (error) {
                    error.classList.add('error')
                }
                let inputs = this.newcust.querySelectorAll('.text-box')
                if (inputs.length > 0) {
                    for (var c = 0; c < inputs.length; c++) {
                        inputs[c].classList.add('errorbox')
                    }
                }
                localStorage.removeItem('form')
            }
        }
    }
}
export default LoginRegister



// WEBPACK FOOTER //
// ./src/resources/scripts/components/LoginRegister.js